import React from "react";
import ReactDOM from "react-dom";
import QRCode from "react-qr-code";
import "./LoyaltyQRModal.css";

const LoyaltyQRModal = ({ open, onClose, userId, userName }) => {
  if (!open) return null;

  const qrValue = `${process.env.REACT_APP_QR_CODE_URL}/loyalty-restaurant-view/${userId}`;

  return ReactDOM.createPortal(
    <div className="qr-modal-overlay" onClick={onClose}>
      <div
        className="qr-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="qr-close-btn" onClick={onClose}>
          ✕
        </button>

        <div className="qr-card">
          <div className="qr-card-inner">
            <div className="qr-code-wrapper">
              <QRCode
                size={256}
                style={{ width: "100%", height: "auto" }}
                value={qrValue}
                level="H"
              />
            </div>

            <span className="customer-id">
              {userName || "Customer Name"}
            </span>

            <p className="qr-instructions">
              Show this QR code at any participating restaurant to view your
              points and redeem rewards.
            </p>
          </div>
        </div>
      </div>
    </div>,
    document.body // 👈 renders outside sidebar
  );
};

export default LoyaltyQRModal;
